
import { LayoutMeetings } from './Layout/LayoutMeetings';

export const MeetingsScreen = ({isCalendar}) => {
    return (
        <>
            <LayoutMeetings />
        </>
    )
}